import { NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { startCase, camelCase } from 'lodash';

export const SetPageTitle = (router: Router, titleService: Title) => () =>
  router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((path: any) => {
    const routePath = path.url.split('/');
    let route = routePath.pop().split('?')[0];
    if (route.includes('#')) {
      route = route.split('#')[0];
    }

    if (/\d/.test(route)) {
      route = routePath[routePath.length - 1];
    }

    const title = route ? `${startCase(camelCase(route))} - ` : '';

    titleService.setTitle(`${title}Living Meaningfully`);
  });
